import { connect } from 'react-redux';
import FastPhoto from './FastPhoto';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  getBaseUrlSelector,
  getUserRoleSelector,
} from '../../../globalState/app/selectros';
import { savePagePhotos } from '../../../globalState/object/actions';

let mapStateToProps = (state) => {
  return {
    objectId: state.object.id,
    photosToDB: state.object?.photo?.photos,
    userRole: getUserRoleSelector(state),
    baseUrl: getBaseUrlSelector(state),
  };
};

export default compose(
  connect(mapStateToProps, { savePagePhotos }),
  withRouter
)(FastPhoto);
